var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompare = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.5815137,18.6109617 L32.110976,18.6109617 L32.110976,25.7224662 L24.5815137,25.7224662 L24.5815137,31.7951059 L14.9536477,22.1672398 L24.5815137,12.5393738 L24.5815137,18.6109617 Z M7.52979828,20.2568769 L7.52941566,14.1855356 L0.000277209616,14.1851279 L-3.37507799e-14,7.07317197 L7.52913845,7.0735796 L7.5287557,1 L17.1577154,10.6289597 L7.52979828,20.2568769 Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompare);
export default ForwardRef;